import { supabase } from "./supabase";

export interface MeetingShare {
  id: string;
  meeting_id: string;
  token: string;
  include_transcript: boolean;
  expires_at: string | null;
  revoked_at: string | null;
  view_count: number;
  created_at: string;
}

function generateToken(): string {
  const bytes = new Uint8Array(24);
  crypto.getRandomValues(bytes);
  return Array.from(bytes)
    .map((b) => b.toString(36).padStart(2, "0"))
    .join("")
    .slice(0, 32);
}

export async function listShares(meetingId: string): Promise<MeetingShare[]> {
  const { data, error } = await supabase
    .from("meeting_shares")
    .select("*")
    .eq("meeting_id", meetingId)
    .is("revoked_at", null)
    .order("created_at", { ascending: false });
  if (error) throw error;
  return (data as MeetingShare[]) ?? [];
}

export async function createShare(
  meetingId: string,
  options: { includeTranscript: boolean; expiresInDays?: number | null } = {
    includeTranscript: false,
  }
): Promise<MeetingShare> {
  const {
    data: { user },
  } = await supabase.auth.getUser();
  if (!user) throw new Error("Not authenticated");
  const expires_at =
    options.expiresInDays && options.expiresInDays > 0
      ? new Date(Date.now() + options.expiresInDays * 86400000).toISOString()
      : null;
  const { data, error } = await supabase
    .from("meeting_shares")
    .insert({
      meeting_id: meetingId,
      user_id: user.id,
      token: generateToken(),
      include_transcript: options.includeTranscript,
      expires_at,
    })
    .select()
    .single();
  if (error) throw error;
  return data as MeetingShare;
}

export async function revokeShare(id: string): Promise<void> {
  const { error } = await supabase
    .from("meeting_shares")
    .update({ revoked_at: new Date().toISOString() })
    .eq("id", id);
  if (error) throw error;
}

export function shareUrl(token: string): string {
  const base =
    typeof window !== "undefined"
      ? window.location.origin
      : "https://redi.axisapps.app";
  return `${base}/share/${token}`;
}
